import { Navigate } from 'react-router-dom';

export default function PrivateBroadcastPage() {
  return <Navigate to="/broadcast?visibility=invite_only&status=all" replace />;
}
